(function () {
  'use strict';

  angular.module('app').service('ServiceItemCostModalService', ServiceItemCostModalService);

  ServiceItemCostModalService.$inject = ['ModalService'];

  function ServiceItemCostModalService(ModalService) {
    let service = {
      openServiceItemCostsModal: openServiceItemCostsModal,
    };

    return service;

    ////////////////

    function openServiceItemCostsModal(
      serviceItem,
      provider,
      viewOption,
      userLanguageCode,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl: './app/ajs/service-item-costs/modals/service-item-costs-modal.html',
        controller: ServiceItemCostsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          serviceItem: serviceItem,
          provider: provider,
          viewOption: viewOption,
          userLanguageCode: userLanguageCode,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        let preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      ServiceItemCostsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'CONFIGURATIONS',
        'serviceItem',
        'provider',
        'viewOption',
        'userLanguageCode',
        'successCallback',
        'ServiceItemService',
        'ServiceItemCostService',
        'PriceListService',
        'ProviderService',

        // Angular downgraded service
        'seasonService',
        'seasonModalService',
        'paxRangeService',
      ];
    }

    function ServiceItemCostsModalCtrl(
      $element,
      UtilService,
      CONFIGURATIONS,
      serviceItem,
      provider,
      viewOption,
      userLanguageCode,
      successCallback,
      ServiceItemService,
      ServiceItemCostService,
      PriceListService,
      ProviderService,

      // Angular downgraded service
      seasonService,
      seasonModalService,
      paxRangeService
    ) {
      let vm = this;

      vm.UtilService = new UtilService(vm);

      vm.dateDisplay = CONFIGURATIONS.DATE_DISPLAY;
      vm.today = CONFIGURATIONS.TODAY_DATE;

      vm.viewOption = viewOption;

      vm.search = {
        provider: null,
      };

      // vm.getAssociatedProvidersOnSave = false;

      // Service item list
      if (viewOption === 'service-item') {
        getServiceItem();
      } else {
        vm.serviceItem = serviceItem;
        vm.provider = provider;

        if (vm.provider.status === 'active') {
          vm.search.provider = vm.provider;
        }

        getSeasons();

        // vm.getAssociatedProvidersOnSave = true;
      }

      // Methods
      vm.groupSeasonsByYears = groupSeasonsByYears;

      vm.openSeasonsModal = openSeasonsModal;
      vm.openPriceListsModal = openPriceListsModal;

      vm.selectSeason = selectSeason;
      vm.selectPriceList = selectPriceList;
      vm.selectProvider = selectProvider;

      vm.searchServiceItemCosts = searchServiceItemCosts;

      vm.onServiceItemCostsSaved = onServiceItemCostsSaved;
      vm.onServiceItemCostsCanceled = onServiceItemCostsCanceled;

      // Initilizers
      getPriceLists();
      getPaxRanges();

      function getServiceItem() {
        vm.loadingServiceItem = true;
        ServiceItemService.getServiceItem(serviceItem.id, { costs: false }).then(function (data) {
          // 'providers_options': 'none'
          vm.serviceItem = data;
          vm.provider = data.default_provider;

          vm.associatedProviders = ProviderService.setAssociatedProviders(
            data.associated_providers,
            true
          );

          if (vm.provider.status === 'active') {
            vm.search.provider = vm.provider;
          }

          vm.loadingServiceItem = false;

          getSeasons();
        });
      }

      // ----- SEASONS -----

      // Get active seasons
      function getSeasons() {
        // current, where to is equal or less than today, check utc
        let params = {
          get: 'current',
          lang: userLanguageCode,
          skip_check_role: true,
        };

        vm.loadingSeasons = true;
        seasonService.getSeasons(params).subscribe((response) => {
          vm.seasons = response.filter((season) => season.name); // In case of empty translation

          if (vm.seasons.length > 0) {
            let currentSeason = vm.seasons[0];

            // By service item
            if (
              vm.viewOption === 'service-item' &&
              vm.serviceItem.current_costs &&
              vm.serviceItem.current_costs.rates_today.season &&
              vm.serviceItem.current_costs.rates_today.season.status === 'active'
            ) {
              currentSeason = vm.serviceItem.current_costs.rates_today.season;
            }

            selectSeason(currentSeason);
          }

          vm.loadingSeasons = false;
        });
      }

      function groupSeasonsByYears(season) {
        return seasonService.groupSeasonsByYears(season);
      }

      function openSeasonsModal() {
        let successCallback = function () {
          getSeasons();
        };

        seasonModalService.openSeasonsModal(successCallback);
      }

      // ----- PRICE LISTS -----

      // Get active price lists
      function getPriceLists() {
        let params = {
          get: 'active',
          contact_type: 'provider',
          skip_check_role: true,
        };

        vm.loadingPriceLists = true;
        PriceListService.getPriceLists(params).then(function (data) {
          vm.priceLists = data.items;

          vm.search.priceList = PriceListService.selectDefaultPriceList(vm.priceLists);
          selectPriceList();

          vm.loadingPriceLists = false;
        });
      }

      function openPriceListsModal() {
        let successCallback = function () {
          getPriceLists();
        };

        PriceListService.openPriceListsModal(successCallback);
      }

      // ----- PAX RANGES -----

      // Get active pax ranges
      function getPaxRanges() {
        paxRangeService
          .getPaxRanges({ get: 'active', skip_check_role: true })
          .subscribe((response) => {
            vm.paxRanges = response;
          });
      }

      function selectSeason(season) {
        vm.seasonSelected = season;

        searchServiceItemCosts();
      }

      function selectPriceList() {
        searchServiceItemCosts();
      }

      function selectProvider() {
        searchServiceItemCosts();
      }

      function searchServiceItemCosts() {
        if (!vm.seasonSelected || !vm.search.priceList || !vm.search.provider) {
          return;
        }

        let filterCriteria = {
          by_season: vm.seasonSelected.id,
          by_price_list: vm.search.priceList.id,
          by_provider_id: vm.search.provider.id,
        };

        vm.serviceItemCosts = null;
        vm.loadingServiceItemCosts = true;
        ServiceItemCostService.searchServiceItemCosts(vm.serviceItem, filterCriteria).then(
          function (data) {
            vm.serviceItemCosts = data;

            vm.loadingServiceItemCosts = false;
          }
        );
      }

      function onServiceItemCostsSaved(dataObj) {
        successCallback(dataObj);
      }

      function onServiceItemCostsCanceled() {
        $element.modal('hide');
      }
    }
  }
})();
